import service from './service';
import { getEndpoints } from "../helpers";

export const getInstrumentsPartnerApi = () => {
    return service.extGetLoan(getEndpoints.loanServiceUrl + "api/loans/instruments-partner");
};